/** The account authenticated, but has no `dispo` permission (spec §7.2). */
export class NoDispoAccessError extends Error {
    constructor() {
        super('Account has no dispo permission');
        this.name = 'NoDispoAccessError';
    }
}
